import { render, staticRenderFns } from "./exportRecognitionsReport.vue?vue&type=template&id=1c5601f7&scoped=true"
import script from "./exportRecognitionsReport.vue?vue&type=script&lang=js"
export * from "./exportRecognitionsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5601f7",
  null
  
)

export default component.exports